import React, { useState, useEffect } from 'react';
import { ReactComponent as CloseIcon } from './icons/close.svg';
import './css/ModalWindow.css';
const ModalWindow = (props) => {

    useEffect(() => {
        //onload execute ....
    }, []);

    return (
        <div className={'modalWindow ' + props.classNameBackdrop}>
            <div className={props.className + ' window'} style={{ width: (props.width) ? props.width : 'auto' }}>
                {props.closeMethod?(
                    <a className="close" onClick={props.closeMethod}><CloseIcon/></a>
                ):null}
                {props.children}
            </div>
        </div>
    );

}

export default ModalWindow;

